import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/share-screen.vue
var o = {
	name: "DtIconShareScreen",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--share-screen"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Share Screen",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M.5 2.5A1.5 1.5 0 0 1 2 1h8a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 10 9H2A1.5 1.5 0 0 1 .5 7.5v-5ZM2 2a.5.5 0 0 0-.5.5v5A.5.5 0 0 0 2 8h8a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 10 2H2Zm4.98.813a.5.5 0 0 1 .707 0l1.111 1.111a.5.5 0 0 1 0 .707L7.687 5.742a.5.5 0 0 1-.707-.707l.257-.257H5.111a.389.389 0 0 0-.389.389v1.555a.5.5 0 0 1-1 0V5.167a1.389 1.389 0 0 1 1.39-1.389h2.125L6.98 3.52a.5.5 0 0 1 0-.707ZM.5 10.5A.5.5 0 0 1 1 10h10a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=share-screen.js.map